import type { BuildSkillsPathParams } from '../types';

/**
 * Builds skills-surface paths from the mount scope's basePath.
 * Never hardcodes `/agents/:agentId` or `/admin/skills`.
 */
const buildSkillsPath = ({ scope, skillId, fileId, versionId }: BuildSkillsPathParams): string => {
    const basePath = scope.basePath.replace(/\/$/, '');

    if (!skillId) {
        return basePath;
    }

    if (versionId) {
        return `${basePath}/${skillId}/versions/${versionId}`;
    }

    if (fileId) {
        return `${basePath}/${skillId}/file/${fileId}`;
    }

    return `${basePath}/${skillId}`;
};

export default buildSkillsPath;
